import { render } from "./AddNewAdmin.vue?vue&type=template&id=7d2d5061"
import script from "./AddNewAdmin.vue?vue&type=script&lang=js"
export * from "./AddNewAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__